import { Lock } from './lock.js';
import { createLogger } from '../logger/logger.js';
import { getOrCreate } from '../utils/get-or-create.js';
import { CustomError } from '../error/custom-error.js';
import { getError } from '../runtime/get-error-message.js';

export function createMemoryLock(): Lock {
  const locks: Record<string, Promise<void>> = {};
  const logger = createLogger('memory-lock');

  function acquire<T>(
    key: string,
    fn: () => Promise<T>,
    signal: AbortSignal,
  ): Promise<T> {
    const existing = getOrCreate(locks, key, () => Promise.resolve());
    logger.debug(`add lock to chain`, { key });
    return new Promise<T>((resolve, reject) => {
      locks[key] = existing.then(() => {
        if (signal.aborted) {
          logger.info(`no not acquire lock because already aborted`, { key });
          reject(new CustomError('lock aborted', {}));
          return;
        }

        logger.debug(`acquire lock`, { key });
        try {
          const result = fn();
          if (result instanceof Promise) {
            return result
              .then((v) => resolve(v))
              .catch((e) => {
                reject(getError(e));
              })
              .then(() => {
                logger.debug(`release lock`, { key });
              });
          } else {
            resolve(result);
          }
        } catch (e) {
          reject(getError(e));
        }

        return Promise.resolve();
      });
    });
  }

  return {
    acquire,
  };
}
